var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.examRoom && _vm.$route.query.battleType != 2
    ? _c("div", { staticClass: "faceTipBox" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ]
          },
          [
            _c("img", {
              attrs: { src: _vm.$t("proctoringQRcode"), alt: "", srcset: "" }
            }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: _vm.$t("QRCodeHover"), alt: "", srcset: "" }
            }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: _vm.$t("QRCodeActive"), alt: "", srcset: "" }
            })
          ]
        ),
        _vm._v(" "),
        _vm.beginRadio.content == 1 &&
        _vm.$route.query.examId === _vm.beginRadio.examId
          ? _c("div", { staticClass: "radioBox" }, [
              _c(
                "div",
                {
                  staticClass: "radioTitle",
                  class: _vm.$i18n.locale === "en" ? "" : "enRadioTitle"
                },
                [_vm._v(_vm._s(_vm.$t("beginRadio")))]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.helpFace,
                expression: "helpFace"
              }
            ],
            staticClass: "cursor helpBox",
            on: {
              click: function($event) {
                return _vm.changeHelp(true)
              }
            }
          },
          [
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.unRead,
                  expression: "unRead"
                }
              ],
              staticClass: "helpBoxTip",
              attrs: {
                src: "https://img.webloom.cn/img/newMessage.png",
                alt: "",
                srcset: ""
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "helpBoxTitle",
              attrs: {
                src:
                  _vm.$i18n.locale === "en"
                    ? "https://img.webloom.cn/img/teacherE1.png"
                    : "https://img.webloom.cn/img/teacherC1.png",
                alt: "",
                srcset: ""
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.helpFace,
                expression: "!helpFace"
              }
            ],
            staticClass: "sendMessage",
            staticStyle: { cursor: "default" }
          },
          [
            _c("div", { staticClass: "input" }, [
              _c("img", {
                staticClass: "closeTip",
                staticStyle: { cursor: "pointer" },
                attrs: {
                  src: "https://img.webloom.cn/img/closeTip.png",
                  alt: ""
                },
                on: { click: _vm.closeTip }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "tipBox",
                  staticClass: "tipBox",
                  attrs: { id: "chatBox" }
                },
                [
                  _vm.chatRecord.length > 0
                    ? _vm._l(_vm.chatRecord, function(vo, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass: "tipBoxItem",
                            class:
                              vo.fromAccountRole === 2 ||
                              vo.fromAccountRole === 8 ||
                              vo.fromAccountRole === 3
                                ? ""
                                : "tipBoxItem1"
                          },
                          [
                            _c("div", { staticClass: "'tipBoxItem1" }, [
                              _vm._v(
                                _vm._s(
                                  vo.fromAccountRole === 2 ||
                                    vo.fromAccountRole === 8
                                    ? _vm.$t("Invigilator")
                                    : vo.fromAccountRole === 3
                                    ? _vm.$t("Administrator")
                                    : _vm.userName
                                ) +
                                  "  " +
                                  _vm._s(
                                    _vm.$utils.timestampToStr(
                                      vo.msgTime,
                                      "Y.M.D h:m:s"
                                    )
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tipBoxItemBox",
                                class:
                                  vo.fromAccountRole === 2 ||
                                  vo.fromAccountRole === 8 ||
                                  vo.fromAccountRole === 3
                                    ? ""
                                    : "tipBoxItemBox1"
                              },
                              [
                                !vo.isQRCode
                                  ? [
                                      vo.fromAccountRole === 1
                                        ? [
                                            vo.noSend === 1
                                              ? _c("img", {
                                                  staticClass:
                                                    "sendDefault sendDefault1",
                                                  attrs: {
                                                    src: require("../../../assets/img/test/tips.png"),
                                                    alt: ""
                                                  },
                                                  on: {
                                                    click: function() {
                                                      ;(_vm.text =
                                                        vo.msgContent),
                                                        _vm.submit(i)
                                                    }
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            vo.beSending
                                              ? _c("img", {
                                                  staticClass: "sendDefault",
                                                  attrs: {
                                                    src:
                                                      "https://img.webloom.cn/img/loading.gif",
                                                    alt: ""
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      vo.fromAccountRole !== 8 &&
                                      vo.fromAccountRole !== 9 &&
                                      vo.msgCommonId !== "26723157079798290" &&
                                      vo.msgCommonId !== "26723157079798277"
                                        ? _c("div", {
                                            staticClass: "tipBoxItemDesc",
                                            class:
                                              vo.fromAccountRole === 2 ||
                                              vo.fromAccountRole === 3 ||
                                              vo.fromAccountRole === 8
                                                ? "monitorMessage2"
                                                : "tipBoxItem2",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.isHttpUrl(vo.msgContent)
                                              )
                                            }
                                          })
                                        : vo.fromAccountRole !== 8 &&
                                          vo.fromAccountRole !== 9 &&
                                          (vo.msgCommonId ===
                                            "26723157079798290" ||
                                            vo.msgCommonId ===
                                              "26723157079798277")
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "tipBoxItemDesc",
                                              class:
                                                vo.fromAccountRole === 2 ||
                                                vo.fromAccountRole === 3 ||
                                                vo.fromAccountRole === 8
                                                  ? "monitorMessage2"
                                                  : "tipBoxItem2"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "answerBox" },
                                                [
                                                  _c("div", {
                                                    staticClass: "answerText",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.isHttpUrl(
                                                          vo.msgContent
                                                        )
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("img", {
                                                    staticClass: "mobileImg",
                                                    attrs: {
                                                      src:
                                                        _vm.language === "zh"
                                                          ? _vm.qrcodeZh
                                                          : _vm.qrcodeEn,
                                                      alt: "",
                                                      srcset: ""
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "tipBoxItemDesc",
                                              class: [
                                                vo.fromAccountRole === 2 ||
                                                vo.fromAccountRole === 8 ||
                                                vo.fromAccountRole === 3
                                                  ? "monitorMessage2"
                                                  : "tipBoxItem2",
                                                vo.fromAccountRole === 9
                                                  ? ""
                                                  : "tipBoxItemDesc1",
                                                vo.level === 3
                                                  ? "tipBoxItemDesc2"
                                                  : ""
                                              ],
                                              staticStyle: {
                                                "white-space": "unset"
                                              }
                                            },
                                            [
                                              vo.fromAccountRole === 9 &&
                                              (vo.levelItem3 > -1 ||
                                                vo.levelItem > -1)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "automaticResponse"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          vo.levelItem3 > -1
                                                            ? _vm.levelList[
                                                                vo.levelItem
                                                              ].levelTwo[
                                                                vo.levelItem3
                                                              ][
                                                                _vm.$t(
                                                                  "automaticName"
                                                                )
                                                              ]
                                                            : vo.levelItem > -1
                                                            ? _vm.levelList[
                                                                vo.levelItem
                                                              ][
                                                                _vm.$t(
                                                                  "automaticName"
                                                                )
                                                              ]
                                                            : ""
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : [
                                                    vo.level === 1 &&
                                                    _vm.levelList.length > 0
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "wantToConsult"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "wantToConsult"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "automaticResponseBox",
                                                              class: {
                                                                automaticResponseBoxUnfold:
                                                                  _vm.unfold &&
                                                                  !_vm.openOneSelf,
                                                                openOneSelf:
                                                                  _vm.openOneSelf
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        _vm.showUnfold,
                                                                      expression:
                                                                        "showUnfold"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "unfoldBox",
                                                                  on: {
                                                                    click:
                                                                      _vm.changeUnfold
                                                                  }
                                                                },
                                                                [
                                                                  _c("div", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "faceTipUnfold"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "unfoldImg",
                                                                    attrs: {
                                                                      src:
                                                                        "https://img.webloom.cn/img/faceTipUnfold.png",
                                                                      alt: "",
                                                                      srcset: ""
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm.levelList,
                                                                function(
                                                                  voi,
                                                                  ii
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: ii,
                                                                      staticClass:
                                                                        "automaticResponseItem"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "ItemClose",
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.clickLevelOne(
                                                                                ii,
                                                                                voi
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "automaticResponse"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  voi[
                                                                                    _vm.$t(
                                                                                      "automaticName"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              class: {
                                                                                openQuestion:
                                                                                  _vm.clickQuestion ===
                                                                                  ii
                                                                              },
                                                                              attrs: {
                                                                                src:
                                                                                  "https://img.webloom.cn/img/faceTipMore.png",
                                                                                alt:
                                                                                  "",
                                                                                srcset:
                                                                                  ""
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm.clickQuestion ===
                                                                      ii
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "itemQuestionBox",
                                                                              class: {
                                                                                openQuestion:
                                                                                  _vm.clickQuestion ===
                                                                                  ii
                                                                              }
                                                                            },
                                                                            _vm._l(
                                                                              _vm
                                                                                .levelList[
                                                                                _vm
                                                                                  .clickQuestion
                                                                              ]
                                                                                .levelTwo,
                                                                              function(
                                                                                voi2,
                                                                                ii2
                                                                              ) {
                                                                                return _c(
                                                                                  "div",
                                                                                  {
                                                                                    key: ii2,
                                                                                    staticClass:
                                                                                      "itemQuestion",
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.clickLevelTwo(
                                                                                          _vm.clickQuestion,
                                                                                          ii2,
                                                                                          voi2[
                                                                                            _vm.$t(
                                                                                              "automaticName"
                                                                                            )
                                                                                          ],
                                                                                          voi2
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticClass:
                                                                                          "itemBlock",
                                                                                        attrs: {
                                                                                          src:
                                                                                            "https://img.webloom.cn/img/itemBlock.png",
                                                                                          alt:
                                                                                            "",
                                                                                          srcset:
                                                                                            ""
                                                                                        }
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        voi2[
                                                                                          _vm.$t(
                                                                                            "automaticName"
                                                                                          )
                                                                                        ]
                                                                                      ) +
                                                                                        "\n                            "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    vo.level === 3
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "answerBox"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "answerText"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    vo.answer[
                                                                      _vm.$t(
                                                                        "automaticName"
                                                                      )
                                                                    ]
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            vo.msgCommonId ===
                                                              "26723157079798290" ||
                                                            vo.msgCommonId ===
                                                              "26723157079798277"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "mobileImg",
                                                                  attrs: {
                                                                    src:
                                                                      _vm.language ===
                                                                      "zh"
                                                                        ? _vm.qrcodeZh
                                                                        : _vm.qrcodeEn,
                                                                    alt: "",
                                                                    srcset: ""
                                                                  }
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            vo.clickSolved !==
                                                            "unSolved"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "isSolved"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "Solved",
                                                                        class: {
                                                                          yesSolved:
                                                                            vo.clickSolved ===
                                                                            "Solved"
                                                                        },
                                                                        staticStyle: {
                                                                          cursor:
                                                                            "pointer"
                                                                        },
                                                                        on: {
                                                                          click: function() {
                                                                            if (
                                                                              vo.clickSolved ===
                                                                              "Solved"
                                                                            ) {
                                                                              return
                                                                            }
                                                                            vo.clickSolved =
                                                                              "Solved"
                                                                            _vm.addAutoRecord(
                                                                              vo.answer,
                                                                              1
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        vo.clickSolved ===
                                                                        "Solved"
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "solvedImg",
                                                                                attrs: {
                                                                                  src:
                                                                                    "https://img.webloom.cn/img/faceTipSolved.png",
                                                                                  alt:
                                                                                    "",
                                                                                  srcset:
                                                                                    ""
                                                                                }
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "solvedImg",
                                                                                attrs: {
                                                                                  src:
                                                                                    "https://img.webloom.cn/img/faceTipIsSolved1.png",
                                                                                  alt:
                                                                                    "",
                                                                                  srcset:
                                                                                    ""
                                                                                }
                                                                              }
                                                                            ),
                                                                        _vm._v(
                                                                          "\n                        " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "Solved"
                                                                              )
                                                                            )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    vo.clickSolved !==
                                                                    "Solved"
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "Solved unSolved",
                                                                            staticStyle: {
                                                                              cursor:
                                                                                "pointer"
                                                                            },
                                                                            on: {
                                                                              click: function() {
                                                                                if (
                                                                                  vo.clickSolved ===
                                                                                  "unSolved"
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                vo.clickSolved =
                                                                                  "unSolved"
                                                                                _vm.addAutoRecord(
                                                                                  vo.answer,
                                                                                  0
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "solvedImg",
                                                                                attrs: {
                                                                                  src:
                                                                                    "https://img.webloom.cn/img/faceTipUnSolved.png",
                                                                                  alt:
                                                                                    "",
                                                                                  srcset:
                                                                                    ""
                                                                                }
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "Unsolved"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            vo.clickSolved ===
                                                            "unSolved"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "clickSolved"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "cannotBeResolved"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                            ],
                                            2
                                          ),
                                      _vm._v(" "),
                                      vo.fromAccountRole === 2
                                        ? [
                                            vo.noSend === 1
                                              ? _c("img", {
                                                  staticClass:
                                                    "sendDefault sendDefault1",
                                                  attrs: {
                                                    src: require("../../../assets/img/test/tips.png"),
                                                    alt: ""
                                                  },
                                                  on: {
                                                    click: function() {
                                                      ;(_vm.text =
                                                        vo.msgContent),
                                                        _vm.submit(i)
                                                    }
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            vo.beSending
                                              ? _c("img", {
                                                  staticClass: "sendDefault",
                                                  attrs: {
                                                    src:
                                                      "https://img.webloom.cn/img/loading.gif",
                                                    alt: ""
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      vo.fromAccountRole === 8
                                        ? [
                                            vo.noSend === 2
                                              ? _c("img", {
                                                  staticClass:
                                                    "sendDefault sendDefault1",
                                                  attrs: {
                                                    src: require("../../../assets/img/test/tips.png"),
                                                    alt: ""
                                                  },
                                                  on: {
                                                    click: function() {
                                                      ;(_vm.text =
                                                        vo.msgContent),
                                                        _vm.submit(i)
                                                    }
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            vo.beSending
                                              ? _c("img", {
                                                  staticClass: "sendDefault",
                                                  attrs: {
                                                    src:
                                                      "https://img.webloom.cn/img/loading.gif",
                                                    alt: ""
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    ref: "qrCodeUrl",
                    staticClass: "qrCodeUrl"
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { ref: "inputBox", staticClass: "inputBox" }, [
                _c(
                  "div",
                  { staticClass: "input" },
                  [
                    _c("el-input", {
                      staticStyle: { "word-break": "break-word" },
                      attrs: {
                        onkeydown: "if (event.keyCode===13){return false;}",
                        onpaste: "return false",
                        oncut: "return false",
                        oncopy: "return false",
                        type: "textarea",
                        placeholder: "",
                        value: _vm.text,
                        maxlength: "1000",
                        resize: "none",
                        autosize: { minRows: 1, maxRows: 4 }
                      },
                      on: { input: _vm.replaceExpression },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submit.apply(null, arguments)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "submit",
                        class: _vm.text.trim().length > 0 ? "" : "noSubmit",
                        on: { click: _vm.submit }
                      },
                      [_vm._v(_vm._s(_vm.$t("faceTipBoxSend")))]
                    )
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-05af945b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-05af945b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/bloom-proctor/public/faceTipBox.vue
// module id = null
// module chunks = 